var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],staticClass:"module module-instagram padding_large",class:[{ 'show-up': _vm.isVisible }, _vm.baseAnimation]},[_c('ModuleContainer',[_c('ModuleHeading',[_vm._v("Instagram")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }